module.exports = __webpack_public_path__ + "img/landline.b731cc1c.svg";